import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ target, onDone, compact = false, testId = "countdown" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = Math.max(0, new Date(target).getTime() - now);
  useEffect(() => {
    if (left === 0 && onDone) onDone();
    return undefined;
  }, [left === 0]); // eslint-disable-line react-hooks/exhaustive-deps

  const s = Math.floor(left / 1000);
  const parts = [["Days", Math.floor(s / 86400)], ["Hours", Math.floor((s % 86400) / 3600)], ["Minutes", Math.floor((s % 3600) / 60)], ["Seconds", s % 60]];
  const shown = parts[0][1] ? parts : parts.slice(1);

  if (compact) {
    return <span data-testid={testId} className="tabular-nums">{shown.map(([l, v]) => `${pad(v)}${l[0].toLowerCase()}`).join(" ")}</span>;
  }
  return (
    <div data-testid={testId} className="flex gap-2 sm:gap-4" aria-live="polite">
      {shown.map(([label, v]) => (
        <div key={label} className="min-w-[68px] border border-white/15 bg-white/[0.04] px-3 py-3 text-center sm:min-w-[96px] sm:px-5 sm:py-5">
          <div className="font-display text-3xl font-extrabold tabular-nums tracking-tight sm:text-5xl">{pad(v)}</div>
          <div className="mt-1 font-mono-label text-[11px] uppercase tracking-[0.2em] text-zinc-400 sm:text-xs">{label}</div>
        </div>
      ))}
    </div>
  );
};
